import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allMachines } from 'app/mocks/data/machines/all'

import { api } from 'app/utils/constants'

export const getMachine = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.machines.ALL}:id/`,
    ({ params }) => {
        const { id } = params
        const machineFound = allMachines.find(
            (machine) => machine.id.toString() === id,
        )

        // Not found
        if (!machineFound) {
            return new HttpResponse(null, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json(machineFound)
    },
)
